import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';

import LetterItem from './Item';
import { getSocketconnection } from '../../../helpers/socket';

function LetterList(props) {
    const [letters, setLetters] = useState(props.letters ? props.letters.data : []);
    const lettersRef = useRef(letters);

    useEffect(() => {
        // trigger capture any letters change (run on every rerender)
        // that prevent keeping old letters state 
        lettersRef.current = letters;
    });

    useEffect(() => {
        setLetters(props.letters.data);
    }, [props.letters.data]);

    /**
     * 
     * @param {UpdateLetterMessage} message 
     * @param {any[]} lettersCurrent 
     */
    const messageHandler = (message, lettersCurrent) => {
        const { mailId, processingCondition } = message;
        const foundLetterIndex = lettersCurrent.findIndex(i => i._id === mailId);

        if (foundLetterIndex >= 0) {
            const clones = _.cloneDeep(lettersCurrent);

            clones[foundLetterIndex] = {
                ...clones[foundLetterIndex],
                processingCondition: [processingCondition],
            };
            setLetters(clones);
        }
    };

    useEffect(() => {
        const socket = getSocketconnection(props);

        /**
         * uses ref to address the last version of letters state
         * @param {UpdateLetterMessage} message 
         */
        const handler = message => messageHandler(message, lettersRef.current);

        socket.on('admin:mail:processingCondition:changed', handler);
    }, []);

    return (
        <div>
            <ul className='letters-collection collection'>
                {
                    letters.map(letter => <LetterItem key={letter._id} item={letter} />)
                }
            </ul>
        </div>
    );
}

export default LetterList;

/**
 * @typedef {Object} UpdateLetterMessage
 * @property {string} mailId
 * @property {ProcessingCondition} processingCondition 
 */

/**
 * @typedef {Object} ProcessingCondition
 * @property {Date} date
 * @property {'pending' | 'sent'} status
 */



// WEBPACK FOOTER //
// ./app/components/Letters/List/List.jsx